import React, { Fragment } from "react";
import { Footerlight, PageLayout } from "../../../Constant";
import ItemListContainer from "./ItemsList";

const Item = () => {
    return (
        <Fragment>
            <ItemListContainer mainTitle={Footerlight} title={Footerlight} parent={PageLayout} />  
        </Fragment>
    )
}
export default Item;